module.exports = __webpack_public_path__ + "static/media/logo.2d25a912.svg";